import { useMutation } from '@tanstack/react-query';

import API from 'configs/API';
import { axiosDelete } from 'utils/apis/axios';

const useRemoveShareLinkRecipient = () => {
  return useMutation({
    mutationFn: async ({ userId, recipientId }) => {
      const url = API.ARTWORK.REMOVE_SHARE_LINK_RECIPIENT(userId, recipientId);
      const response = await axiosDelete(false, url);
      return response;
    },
  });
};

export default useRemoveShareLinkRecipient;
